<template>
    <div class="row mt-2 mb-2 d-flex justify-content-between">
        <div class="col-12">
            <v-stepper
                flat
                :value="step"
            >
                <v-stepper-header>
                    <v-stepper-step
                        step="1"
                        :complete="step > 1"
                    >
                        Audience
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        step="2"
                        :complete="step > 2"
                    >
                        Recurrence
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        step="3"
                        :complete="step > 3"
                    >
                        Endpoint
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        step="4"
                        :complete="step > 4"
                    >
                        Properties
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        step="5"
                        :complete="step > 5"
                    >
                        DataStreams
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        step="6"
                        :complete="step === 6"
                        color="success"
                    >
                        Completed
                    </v-stepper-step>
                </v-stepper-header>
            </v-stepper>
            <v-divider></v-divider>
        </div>
    </div>
</template>

<script>

export default {
    name: "SchedulerStepper",
    props: [],
    data: () => ({
        //
    }),
    methods: {
        //
    },
    created() {
        //
    },
    mounted() {
        //
    },
    computed: {
        step: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerStep']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_STEP', value)
            }
        },
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>